/**
 * 工作台 路由
 * meta
 * pPath 用于顶部菜单 选中(尤其在详情页面，其父类菜单要求时选中的)
 * head 默认显示导航1，2显示导航2, -1不显示导航
 * whiteBackground: 默认为灰色背景 true 为白色背景
 * roles 角色 展商（ACTOR）,客商（VISITOR）,游客（''）
 * singleRouter 单独路由存在权限判断
 * noPermissionPath 没有路由权限时，跳转的页面
 * routerType 路由类型 work=>工作台路由 nav=>导航路由 loginAndRegistration => 登录，注册相关路由
 */
const routerWorkbench = [
    {
        // vip申请
        path: '/vip',
        name: 'VIP',
        component: () => import('../views/vip/vip.vue'),
        meta: {
            title: 'vip.vip',
            whiteBackground: true,
            roles: ['VISITOR'],
            singleRouter: true,
            noPermissionPath: "/",
            routerType: 'work'
        }
    },
    {
        // 入场凭证
        path: '/voucher',
        name: 'Voucher',
        component: () => import('../views/groupPreRegistration/index.vue'),
        meta: {
            title: 'gPreReg.voucher',
            whiteBackground: true,
            roles: ['VISITOR'],
            routerType: 'work'
        }
    },
    {
        // 为同事预登记
        path: '/preRegistration/group',
        name: 'GroupPreRegistration',
        component: () => import('../views/groupPreRegistration/index.vue'),
        meta: {
            title: 'gPreReg.moduleName',
            whiteBackground: true,
            roles: ['VISITOR'],
            routerType: 'work'
        }
    },
    {
        // 为同事预登记 表单
        path: '/preRegistration/index/:id?',
        name: 'GroupPreRegistrationForm',
        component: () => import('../views/groupPreRegistration/form.vue'),
        props: true,
        meta: {
            title: 'gPreReg.moduleName',
            whiteBackground: true,
            roles: ['VISITOR'],
            pPath: '/voucher',
            routerType: 'work'
        }
    }
]

export default routerWorkbench
